import { selectIsGhostChat } from './agentsChatsReducer';
import { AgentChat, AgentChatProps } from './AgentChat';
import AgentChatEmptyState from './AgentChatEmptyState';
import { useSelector } from 'react-redux';
import { useAgentChatInstance } from './AgentChatInstanceContext';
import useAgentsChats from './useAgentsChats';
import { useAgentSettingsContext } from './AgentSettingsContext';
import { SettingSection } from './agentSettings/AgentSettingsDialog';
import { AI_AGENTS_INFO } from './aiAgentsConsts';
import { Typography, colors, Button } from '@sweep-io/sweep-design';

const AgentChatEntryPoint = (props: AgentChatProps) => {
  const { chatInstanceId } = useAgentChatInstance();
  const isGhostChat = useSelector(selectIsGhostChat(chatInstanceId));
  const { activeAgent } = useAgentsChats();
  const { openSettings } = useAgentSettingsContext();

  // Check if this agent supports best practices
  const agentInfo = activeAgent ? AI_AGENTS_INFO[activeAgent.type] : null;
  const isSupportBestPractices = agentInfo?.isSupportBestPractices ?? false;

  // Check if agent has best practices
  const hasBestPractices = activeAgent?.bestPractices && activeAgent.bestPractices.length > 0;

  // Should show the best practices subtitle when:
  // 1. Agent supports best practices
  // 2. Agent has no best practices currently
  const shouldShowBestPracticesSubtitle = isSupportBestPractices && !hasBestPractices;

  const handleAddBestPractices = () => {
    openSettings(SettingSection.BestPractices);
  };

  // Create the best practices subtitle JSX when needed
  const bestPracticesSubtitle = shouldShowBestPracticesSubtitle ? (
    <Typography variant="body" color={colors.grey[700]}>
      Agent is set up -{' '}
      <span style={{ verticalAlign: 'bottom' }}>
        <Button variant="flat-blue" size="small" onClick={handleAddBestPractices}>
          add best practices
        </Button>
      </span>{' '}
      to start detecting issues.
    </Typography>
  ) : undefined;

  if (isGhostChat) {
    return (
      <AgentChatEmptyState
        customSubtitle={bestPracticesSubtitle}
        hideIssuesTable={shouldShowBestPracticesSubtitle}
        panelButtons={props.panelButtons}
      />
    );
  }

  return <AgentChat {...props} />;
};

export default AgentChatEntryPoint;
